import { create } from "zustand";
import { persist } from "zustand/middleware";

interface HostNameStore {
	hostName: string;
	setHostName: (hostName: string) => void;
}

const useHostNameStore = create<HostNameStore>()(
	persist(
		(set) => ({
			hostName: "",
			setHostName: (hostName: string) => set({ hostName }),
		}),
		{
			name: "hostName-storage",
		}
	)
);

export default useHostNameStore;
